import React, { Component } from "react";
import { FormGroup } from "react-bootstrap";
import { MentionsInput, Mention } from "react-mentions";
import "./CommentSection.css";

class CommentSection extends Component {
  constructor(props) {
    super(props);
    this.mentionsInputRef = React.createRef();
    this.commentsContainerRef = React.createRef();
    this.state = {
      comments: props.comments || [],
      newComment: "",
      commentError: null,
      isLoading: false,
      expandedCommentId: null,
      replyingTo: null,
      mentionedUsers: [],
      plainTextComment: "",
      user_role_arr: {
        1: "SuperAdmin",
        2: "Admin",
        3: "User",
        4: "Third Party",
        5: "Rider",
        6: "Lab Partner",
        7: "Lab Rider",
        8: "Supplier",
        9: "Doctor",
        10: "Courier Partner",
        11: "Pharmacist",
        12: "Partner",
        13: "Procurement",
        14: "Insurance",
        15: "Insurance Ref",
        16: "Reviewer",
        17: "Store Manager",
        18: "Store Phamasist",
      },
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.loadingTimeout = setTimeout(() => {
      this.setState({ isLoading: false });
    }, 10000);
    if (this.props.hasCommentId) {
      this.focusMentionsInput();
    }
  }
  componentWillUnmount() {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.comments !== this.props.comments) {
      this.setState({ comments: this.props.comments || [], isLoading: false });
    }
    if (!prevProps.hasCommentId && this.props.hasCommentId) {
      this.focusMentionsInput();
    }
  }

  focusMentionsInput = () => {
    setTimeout(() => {
      if (this.mentionsInputRef.current) {
        this.mentionsInputRef.current.focus();
      }
    }, 0);
  };

  getTimeAgo = (timestamp) => {
    const commentDate = new Date(timestamp);
    // Show full date and time for clarity
    return commentDate.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  handleCommentChange = (e, value, plainTextValue, mentions) => {
    const mentionedUsers = mentions
      ? mentions.map((m) => ({ id: m.id, label: m.display }))
      : [];

    this.setState({
      newComment: value,
      plainTextComment: plainTextValue,
      mentionedUsers,
      commentError: null,
    });

    this.props.onMentionChange && this.props.onMentionChange(mentionedUsers);
  };

  handleAddComment = () => {
    const { plainTextComment, mentionedUsers } = this.state;
    if (!plainTextComment.trim()) {
      this.setState({ commentError: "Comment cannot be empty" });
      return;
    }
    const author = this.getCurrentUserName();
    const comment = {
      id: Date.now(),
      author,
      text: plainTextComment,
      mentions: mentionedUsers,
      timestamp: new Date().toISOString(),
      avatar:
        "https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/avatar_icon.png",
    };
    this.setState(
      (prevState) => ({
        comments: [...prevState.comments, comment],
        newComment: "",
        plainTextComment: "",
        commentError: null,
      }),
      () => {
        // Scroll to top to show latest comment
        if (this.commentsContainerRef.current) {
          this.commentsContainerRef.current.scrollTop = 0;
        }
      }
    );

    if (this.props.onAddComment) {
      this.props.onAddComment(comment);
    }
  };

  handleDeleteComment = (commentId) => {
    if (window.confirm("Are you sure you want to delete this comment?")) {
      const { comments } = this.state;
      const updatedComments = comments.filter((c) => c.id !== commentId);
      this.setState({ comments: updatedComments });
      if (this.props.onDeleteComment) {
        this.props.onDeleteComment(commentId);
      }
    }
  };
  renderHighlightedText = (text, mentions = []) => {
    if (!text) return "";
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // Build list of mentions to consider: prefer provided `mentions`,
    // otherwise try to derive from `UserListData` prop or auto-detect `@...` patterns.
    let mentionsToUse = mentions && mentions.length ? mentions.slice() : [];

    if (!mentionsToUse.length) {
      const users = this.props.UserListData || [];
      users.forEach((u) => {
        if (!u || !u.label) return;
        const label = u.label;
        const escaped = escapeRegExp(label);
        const testRegex = new RegExp(`@?${escaped}`, "i");
        if (testRegex.test(text)) {
          mentionsToUse.push({ id: u.value || label, label });
        }
      });
    }

    // Fallback: find any @mention-like sequences (stops at punctuation/newline or another @)
    if (!mentionsToUse.length) {
      const auto = text.match(/@[^@\n,.;!?]+/g);
      if (auto) {
        auto.forEach((m, i) => {
          const label = m.replace(/^@/, "").trim();
          if (label) mentionsToUse.push({ id: m, label });
        });
      }
    }

    if (!mentionsToUse.length) return text;

    let parts = [text];

    mentionsToUse.forEach((mention) => {
      const escaped = escapeRegExp(mention.label);
      // Match either @Name or Name, case-insensitive
      const regex = new RegExp(`(@?${escaped})`, "gi");

      parts = parts.flatMap((part) => {
        if (typeof part !== "string") return part;
        const out = [];
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(part)) !== null) {
          const idx = match.index;
          if (idx > lastIndex) out.push(part.substring(lastIndex, idx));
          out.push(
            <span key={`${mention.id}-${idx}`} className="mention-highlight">
              {match[1]}
            </span>
          );
          lastIndex = idx + match[1].length;
        }
        if (lastIndex < part.length) out.push(part.substring(lastIndex));
        return out;
      });
    });

    return parts;
  };

  toggleExpandComment = (commentId) => {
    this.setState((prevState) => ({
      expandedCommentId:
        prevState.expandedCommentId === commentId ? null : commentId,
    }));
  };

  getCurrentUserName = () => {
    const storedUser = JSON.parse(localStorage.getItem("user")) || {};
    return storedUser.name || "Anonymous";
  };

  getSortedComments = () => {
    const { comments } = this.state;
    return [...comments].sort((a, b) => {
      const dateA = new Date(a.created_at || a.timestamp);
      const dateB = new Date(b.created_at || b.timestamp);
      return dateB - dateA; // Descending order (newest first)
    });
  };

  render() {
    const { newComment, commentError, expandedCommentId } = this.state;
    const {
      title = "Comments",
      readOnly = false,
      disableAfterFirstComment = false,
    } = this.props;
    const UserListData = this.props.UserListData || [];
    const currentUser = this.getCurrentUserName();
    const sortedComments = this.getSortedComments();
    return (
      <div className="comment-section-wrapper">
        {/* Header Section */}
        <div className="comment-header-section">
          <div className="comment-header-content">
            <h3 className="comment-section-title">
              <i className="fa fa-comments"></i> {title}
            </h3>
            <span className="comment-count">
              {sortedComments.length}{" "}
              {sortedComments.length === 1 ? "comment" : "comments"}
            </span>
          </div>
        </div>

        {/* Add Comment Form */}
        {!readOnly && (
          <div className="add-comment-section">
            <div className="add-comment-form">
              <FormGroup className="comment-input-group">
                <MentionsInput
                  inputRef={this.mentionsInputRef}
                  value={newComment}
                  onChange={this.handleCommentChange}
                  placeholder="Share your thoughts about this order..."
                  className="mentions"
                  rows={3}
                  markup="@[__display__](__id__)"
                >
                  <Mention
                    trigger="@"
                    data={UserListData.map((u) => ({
                      id: u.value,
                      display: u.label,
                      email: u.email || "",
                      role: u.role || "",
                    }))}
                    displayTransform={(id, display) => `@${display}`}
                    renderSuggestion={(suggestion, focused) => (
                      <div
                        className="display_main_container"
                        style={{
                          backgroundColor: focused ? "#f0f0f0" : "white",
                        }}
                      >
                        <div className="show_display_suggestion">
                          {suggestion.display}
                        </div>
                        <div className="show_user_email">
                          {suggestion.email} -{" "}
                          {this.state.user_role_arr[suggestion.role]}
                        </div>
                      </div>
                    )}
                  />
                </MentionsInput>
                {commentError && (
                  <small className="comment-error">
                    <i className="fa fa-exclamation-circle"></i> {commentError}
                  </small>
                )}
              </FormGroup>
              <div className="comment-actions-footer">
                <button
                  onClick={this.handleAddComment}
                  className="add-comment-btn"
                  disabled={
                    disableAfterFirstComment && sortedComments.length > 0
                  }
                >
                  <i className="fa fa-send"></i> Post Comment
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Comments Display - Slack Style */}
        <div className="comments-container" ref={this.commentsContainerRef}>
          {this.state.isLoading && sortedComments.length === 0 ? (
            <div className="comments-loading">
              <i className="fa fa-spinner fa-spin"></i>
              <p>Loading comments...</p>
            </div>
          ) : sortedComments.length > 0 ? (
            <div className="comments-list">
              {sortedComments.map((comment, index) => {
                const isSystemMessage = comment.author == "System";

                if (isSystemMessage) {
                  return (
                    <div key={comment.id} className="system-notification">
                      <div className="system-notification-content">
                        <i className="fa fa-info-circle"></i>
                        <span className="system-message-text">
                          {comment.text}
                        </span>
                        <span className="system-message-time">
                          {this.getTimeAgo(
                            comment.created_at || comment.timestamp
                          )}
                        </span>
                      </div>
                    </div>
                  );
                }

                return (
                  <div
                    key={comment.id}
                    className="slack-message-item"
                    onMouseEnter={() => this.toggleExpandComment(comment.id)}
                    onMouseLeave={() => this.toggleExpandComment(null)}
                  >
                    {/* Avatar */}
                    {!isSystemMessage && (
                      <div className="slack-avatar">
                        <img
                          src={comment.avatar}
                          alt={comment.author}
                          title={comment.author}
                        />
                      </div>
                    )}

                    {/* Message Content */}
                    <div className="slack-message-content">
                      {/* Header: Author and Timestamp */}
                      <div className="slack-message-header">
                        <span className="slack-author">{comment.author}</span>
                        <span className="slack-timestamp">
                          {this.getTimeAgo(
                            comment.created_at || comment.timestamp
                          )}
                        </span>
                      </div>

                      {/* Message Body */}
                      <div className="slack-message-body">
                        <p>
                          {this.renderHighlightedText(
                            comment.text,
                            comment.mentions
                          )}
                        </p>
                      </div>

                      {/* Actions - Shown on Hover */}
                      {!readOnly && expandedCommentId === comment.id && (
                        <div className="slack-message-actions">
                          {/* only able to delete own comments not others */}
                          {comment.author === currentUser && (
                            <button
                              className="slack-action-btn delete-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleDeleteComment(comment.id);
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-comments-state">
              <div className="no-comments-icon">
                <i className="fa fa-comments"></i>
              </div>
              <p className="no-comments-text">No comments yet</p>
              <p className="no-comments-subtext">
                Be the first to share your thoughts about this order
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CommentSection;
